import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { PasswordValidation } from '@validators/password-validation';
import { UsersService } from 'app/main/settings/accounts/users/services/users-resolver.service';
import { sentry } from 'sentry';
import { ChangePasswordService } from './change-password.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ChangePasswordComponent = /** @class */ (function () {
    function ChangePasswordComponent(user, formBuilder, usersService, changePasswordService, customMessageService, fuseProgressBarService, matDialogRef, fuseTranslationLoaderService) {
        this.user = user;
        this.formBuilder = formBuilder;
        this.usersService = usersService;
        this.changePasswordService = changePasswordService;
        this.customMessageService = customMessageService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.isLoading = false;
        this.showPassword = false;
        this.showNewPassword = false;
        this.showNewPasswordConfirm = false;
        this.isOnEditDialog = !!(this.user.id);
        this.userType = this.user['__typename'];
        this.passwordMatches = [
            { translate: 'CHARACTERS', regex: '^.{8,}$' },
            { translate: 'UPPER_CASE_LETTER', regex: '[A-Z]{1,}' },
            { translate: 'LOWER_CASE_LETTER', regex: '[a-z]{1,}' },
            { translate: 'ONE_DIGIT', regex: '[0-9]{1,}' },
            { translate: 'ONE_SPECIAL_CHARACTER', regex: '[^a-zA-Z0-9]{1,}' }
        ];
    }
    ChangePasswordComponent.prototype.ngOnInit = function () {
        this.createPasswordForm();
    };
    ChangePasswordComponent.prototype.createPasswordForm = function () {
        var passwordForm = {
            password: [null, [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(new RegExp('[0-9]{1,}')),
                    Validators.pattern(new RegExp('[a-z]{1,}')),
                    Validators.pattern(new RegExp('[A-Z]{1,}')),
                    Validators.pattern(new RegExp('[^a-zA-Z0-9]{1,}'))
                ]],
            confirmPassword: [null, Validators.required]
        };
        if (this.userType === 'AuthenticatedUser') {
            passwordForm['currentPassword'] = [null, Validators.required];
        }
        this.passwordForm = this.formBuilder.group(passwordForm, {
            validator: PasswordValidation.validate.bind(this)
        });
        if (this.userType === 'User') {
            this.passwordForm.get('password').setValue(this.changePasswordService.generatePassword());
            this.showNewPassword = true;
        }
    };
    ChangePasswordComponent.prototype.matchValue = function (regex, value) {
        if (!value) {
            return false;
        }
        return RegExp(regex).test(value);
    };
    ChangePasswordComponent.prototype.saveNewPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        if (!!this.isOnEditDialog) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getNewUserPassword()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.updateAnExistingUsersPassword()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'NewUserPasswordHasBeenUsedBefore') {
                            this.passwordForm.get('password').setErrors({ usedBefore: true });
                            return [2 /*return*/];
                        }
                        if (code === 'InvalidPasswordException' || code === 'NotAuthorizedException') {
                            this.passwordForm.get('currentPassword').setErrors({ invalid: true });
                            return [2 /*return*/];
                        }
                        if (code === 'LimitExceededException') {
                            this.matDialogRef.close();
                            this.customMessageService.error('CHANGE_PASSWORD.MESSAGES.TOO_MANY_REQUESTS_ERROR');
                            return [2 /*return*/];
                        }
                        sentry.captureException(err_1);
                        this.customMessageService.error('CHANGE_PASSWORD.MESSAGES.CHANGE_PASSWORD_ERROR');
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        this.matDialogRef.disableClose = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ChangePasswordComponent.prototype.getNewUserPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.matDialogRef.close({
                            password: this.passwordForm.value.password
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangePasswordComponent.prototype.updateAnExistingUsersPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.matDialogRef.disableClose = true;
                        if (!(this.userType === 'User')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.usersService.setUserPassword(this.user.id, {
                                password: this.passwordForm.value.password,
                                permanentPassword: false
                            }).toPromise()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(this.userType === 'AuthenticatedUser')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.changePasswordService.changeUserPassword({
                                newPassword: this.passwordForm.value.password,
                                oldPassword: this.passwordForm.value.currentPassword
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.customMessageService.success('CHANGE_PASSWORD.MESSAGES.CHANGE_PASSWORD_SUCCESS');
                        this.matDialogRef.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ChangePasswordComponent;
}());
export { ChangePasswordComponent };
